import { colorOf } from "@/lib/status";

// `color` dipakai kalau label yang ditampilkan bukan kunci warna (mis. sel persen "52.1%").
export const StatusBadge = ({ status, testId, color }) => {
  const c = color || colorOf(status);
  return (
    <span
      data-testid={testId}
      className="inline-flex items-center gap-1.5 rounded-full border px-2.5 py-0.5 text-xs font-semibold whitespace-nowrap"
      style={{ color: c, borderColor: `${c}55`, background: `${c}14` }}
    >
      <span className="h-1.5 w-1.5 rounded-full" style={{ background: c }} />
      {status || "—"}
    </span>
  );
};
